import React from 'react';
import PropTypes from 'prop-types';

import FilterPill from 'common/components/filter-pill';

import './index.scss';

export default class FilterPillsBar extends React.Component {
  static propTypes = {
    filterSelections: PropTypes.object,
    ignoreSelections: PropTypes.array,
    onPillClose: PropTypes.func,
    valueMap: PropTypes.object,
  };

  static defaultProps = {
    ignoreSelections: [
      'page',
      'start',
      'end',
      'periodField',
      'q',
      'calendarize_by',
      'namespace',
      'period',
      'tz',
      'sort',
      'dir',
      'ids',
    ],
  };

  getFlattenedSelections(selectionMap) {
    if (!selectionMap) {
      return [];
    }

    const selections = [];

    for (const key of Object.keys(selectionMap)) {
      if (this.props.ignoreSelections.indexOf(key) > -1) {
        continue;
      }

      const values = selectionMap[key];
      if (typeof values === 'string') {
        if (!values) {
          // include pill if something was actually selected
          // 'All' selection sends empty string and shouldn't be shown
          continue;
        }
        selections.push([key, values]);
      } else if (Array.isArray(values)) {
        for (const value of values) {
          selections.push([key, value]);
        }
      }
    }

    return selections;
  }

  render() {
    const selections = this.getFlattenedSelections(this.props.filterSelections);
    return (
      selections.length > 0 && (
        <div className={'FilterPillsBar'}>
          {selections.map(([category, selection]) => (
            <FilterPill
              category={category}
              key={`FilterPill--${category}-${selection}`}
              onClose={this.props.onPillClose}
              selection={selection}
              valueMap={this.props.valueMap}
            />
          ))}
        </div>
      )
    );
  }
}
